import { Title } from "@tremor/react"

export const MetricTitle = ({ title, subtitle = null, className = null }) => {
    return (
        <Title className={`text-gray-700 !text-lg font-semibold mb-5 ${className}`}>{title}</Title>
    )
}